export default __webpack_public_path__ + "static/pro-2-4e76c78c4995b558f5ec753c7cf870b8.jpg";